import '../../../App.css';
import './AllEventMarketWisePL.css';
import { useState, useEffect } from 'react';
import { Input, Table, Select, Pagination } from 'antd';
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom'
import axios from 'axios';
import Appconfig from '../../../config/config'
import moment from 'moment';
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { DatePicker, Button } from 'antd';
import dayjs from 'dayjs';
const { Option } = Select;


function ProfitLoss({ user_id }) {
    const userInfo = JSON.parse(localStorage.getItem('userdata'))
    const navigate = useNavigate();

    // Default: from_date = 7 days ago at 11:59, to_date = today at 11:59
    const defaultFrom = moment().subtract(7, 'days').set({ hour: 11, minute: 59 }).toDate();
    const defaultTo = moment().set({ hour: 11, minute: 59 }).toDate();

    const [formData, setFormData] = useState({
        "user_id": user_id ? user_id : userInfo._id,
        "from_date": defaultFrom,
        "to_date": defaultTo,
        "type": "All",
    });
    const [requestType, setRequestType] = useState('');

    // ***************  Calendar Start ****************

    const [showFromCalendar, setShowFromCalendar] = useState(false);

    const handleChangeType = (value) => {
        if (value) {
            setFormData({
                ...formData,
                type: value
            })
        }
    };

    const handleFromDate = (newDate) => {

        if (newDate) {
            setFormData({
                ...formData,
                from_date: newDate
            })
            setShowFromCalendar(false);
        }
        // Hide the calendar after selecting a date
    };

    const toggleFromCalendar = () => {
        setShowFromCalendar(!showFromCalendar);
        setShowToCalendar(false);
    };

    const [showToCalendar, setShowToCalendar] = useState(false);

    const handleToDate = (newDate) => {
        if (newDate) {
            setFormData({
                ...formData,
                to_date: newDate
            })
            //   setToDate(newDate);
            setShowToCalendar(false); // Hide the calendar after selecting a date
        }

    };

    const toggleToCalendar = () => {
        setShowToCalendar(!showToCalendar);
        setShowFromCalendar(false);
    };
    const formattedFromDate = formData.from_date ? format(formData.from_date, 'dd-MM-yyyy') : format(new Date, 'dd-MM-yyyy');
    const formattedToDate = formData.to_date ? format(formData.to_date, 'dd-MM-yyyy') : format(new Date, 'dd-MM-yyyy');
    console.log("Formatted Date:", formattedFromDate); // Debug: log the formatted date

    // ***************  Calendar End ****************

    let locale = {
        emptyText: 'No data!',
    };

    const navigateToDetails = (record) => {
        // if (get_user_id) {
        navigate(`/reports/event-wise-profit-loss-bet-history`, { state: { from_date: formData.from_date, to_date: formData.to_date, event_type: record?.event_type, is_casino: record?.is_casino, event_id: record?.match_id, market_id: record?.market_id ? record?.market_id : record?.market_name, betting_type: record?.betting_type, selection_id: record?.selection_id, user_idd: record?.user_id } });
        // } else {
        //     navigate(`/reports/event-market-user-wise-pl`, { state: { from_date: formData.from_date, to_date: formData.to_date, event_type: record?.event_type, is_casino: record?.is_casino, event_id: record?.match_id, market_id: record?.market_id, market_name: record?.market_name, betting_type: record?.betting_type, selection_id: record?.selection_id, get_user_id: record?.user_id ? record?.user_id : '' } });
        // }
    };

    const columns = [
        {
            title: 'Sport Name',
            sorter: true,

            render: (_, record) => (
                record.event_type == 4 ?
                    (
                        <div className=' '>
                            Cricket
                        </div>
                    ) : record.event_type == 2 ? (
                        <div className=' '>
                            Tennis
                        </div>
                    ) : record.event_type == 1 ? (
                        <div className=' '>
                            Soccer
                        </div>
                    ) : record.event_type == 777 ? (
                        <div className=' '>
                            WCO Casino
                        </div>
                    ) : record.event_type == 7 ? (
                        <div className=' '>
                            Horse Racing
                        </div>
                    ) : record.event_type == 1004 || record.event_type == 1005 || record.event_type == 1007 || record.event_type == 1008 || record.event_type == 1009 ? (
                        <div className=' '>
                            Casino
                        </div>
                    ) : record.event_type == 4339 ? (
                        <div className=' '>
                            Greyhound Racing
                        </div>
                    ) : record.event_type == 27979456 ? (
                        <div className=' '>
                            Kabaddi
                        </div>
                    ) : record.event_type == 7522 ? (
                        <div className=' '>
                            Basketball
                        </div>
                    ) : record.event_type == 2378961 ? (
                        <div className=' '>
                            Politics
                        </div>
                    ) : record.event_type == 66101 ? (
                        <div className=' '>
                            Virtual
                        </div>
                    ) : record.event_type == 66104 ? (
                        <div className=' '>
                            Lottery
                        </div>
                    ) : record.type ? (
                        <div className=' '>
                            {record.type}
                        </div>
                    ) : (
                        <div className=' '>
                            Casino
                        </div>
                    )
            ),
        }, {
            title: 'Event Name',
            sorter: true,

            render: (_, record) => (
                record.type ? (
                    <div className='' >
                        {record.remarks}
                    </div>
                ) : (
                    <div className='' >
                        {record.event_type == 777 ? record.remarks : record.event_name}
                    </div>
                )

            ),
        },
        {
            title: 'Market Id',
            sorter: true,

            render: (_, record) => (
                record.market_name == "Fancy" ? (
                    <div className=''>
                        {/* {record.selection_id} */} -
                    </div>
                ) : (
                    <div className=''>
                        {record.market_id}
                    </div>
                )

            ),
        }, {
            title: 'Market Name',
            sorter: true,

            render: (_, record) => (

                record.event_type == 777 || record.type ? (
                    <div className=''>
                        -
                    </div>
                ) : (
                    <a hred="javascript:void(0);" onClick={() => navigateToDetails(record)} className='text-[#2789ce] text-[0.813rem]'>
                        {record.market_name + " / " + record.place_name}
                    </a>
                    // <Link style={{color : '#0d6efd'}} className='' to={`/profit-loss-bet-history/${record.match_id}/${record.market_name}/${record.market_id ? record.market_id : record.selection_id}/${formData?.from_date}/${formData?.to_date}`}>
                    //     {record.market_name + ' / ' + record.place_name}
                    // </Link>
                )
            ),
        },
        {
            title: 'Result',
            sorter: true,

            render: (_, record) => (
                <div className=''>
                    {record?.result_name ? record?.result_name : '-'}
                </div>
            ),
        },
        {
            title: 'Profit/Loss',
            dataIndex: 'name',
            sorter: true,
            render: (_, record) => (

                record.type == "Free Chip" ? (
                    <div>
                        {
                            record.transaction_type ==
                                "Credit" ?
                                <span style={{ color: "", fontSize: '0.813rem' }}>{record.amount}</span>
                                :
                                <span style={{ color: "red", fontSize: '0.813rem' }}>{'- ' + record.amount}</span>
                        }

                    </div>
                ) :
                    (
                        record.totalPL < 0 ? (
                            <span className='' style={{ color: 'red' }}>
                                {record?.totalPL?.toFixed(2)}
                            </span>
                        ) : (
                            <span className=' ' >{
                                record?.totalPL?.toFixed(2)
                            }</span>
                        )
                    )
            )
        },
        {
            title: "Total Balance",
            sorter: true,
            render: (_, record) => {
                const totalBalance = Number(
                    record?.totalBalance
                );

                return (
                    <span className="statement-balance-value">
                        {Number.isFinite(totalBalance)
                            ? totalBalance.toFixed(0)
                            : "-"}
                    </span>
                );
            },
        },
        // {
        //     title: 'Commission',
        //     dataIndex: 'name',
        //     sorter: true,
        //     render: (_, record) => (
        //         <span className=''> {record?.commissionAmount?.toFixed(2)}</span>
        //     )
        // },
        {
            title: 'Settle Time',
            sorter: true,

            render: (_, record) => (
                record.event_type == 777 || record.type ? (
                    <div className=''>
                        {new Date(record.createdAt).toLocaleString()}
                    </div>
                ) : (
                    <div className=''>
                        {new Date(record.settledTime).toLocaleString()}
                    </div>
                )

            ),
        },
    ];

    const columnsdw = [
        // {
        //   title: 'Sr.no',
        //   dataIndex: '',
        //   render: (_, record, index) => (
        //     <span className=' '>
        //       {index}
        //     </span>
        //   )
        // },
        {
            title: 'Date',
            dataIndex: 'createdAt',
            sorter: true,
            render: (_, record) => (
                <span style={{ color: "#212529", fontWeight: 800, fontSize: '0.813rem' }}>{new Date(record.createdAt).toLocaleString()}</span>
            ),
        },
        {
            title: 'Remark',
            dataIndex: 'remarks',
            sorter: true,
            render: (_, record) => (
                <span style={{ color: "#212529", fontWeight: 800, fontSize: '0.813rem' }}>{record.remarks}</span>
            ),
        },
        {
            title: 'Deposit',
            dataIndex: 'amount',
            sorter: true,
            render: (_, record) => (
                record.transaction_type ==
                    "Credit" ?
                    <span style={{ color: "#508d0e", fontWeight: 800, fontSize: '0.813rem' }}>{record.amount}</span>
                    : '-'
            ),
        },
        {
            title: 'Withdraw',
            dataIndex: 'name',
            sorter: true,
            render: (_, record) => (
                record.transaction_type == "Debit" ?
                    // record.amount
                    <span style={{ color: "#d50000", fontWeight: 800, fontSize: '0.813rem' }}>{record.amount}</span>
                    : '-'
            ),
        },
        {
            title: 'From/To',
            sorter: true,
            render: (_, record) => (
                <span style={{ color: "#212529", fontWeight: 800, fontSize: '0.813rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {record.from}
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 17V7L16 12L9 17Z" />
                    </svg>
                    {record.to}
                </span>
            ),
        },
        {
            title: 'Balance',
            dataIndex: 'balance',
            sorter: true,
            render: (_, record) => (
                <span style={{ color: "#212529", fontWeight: 800, fontSize: '0.813rem' }} >{record.balance}</span>
            ),
        },
    ];


    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const handlePageSizeChange = (e) => {
        setPageSize(e);
        setCurrent(1); // Reset to the first page after changing page size
    };

    const normalizedSearchText = searchText
        .trim()
        .toLowerCase();

    const searchedData = Array.isArray(filteredData)
        ? filteredData.filter((record) => {
            if (!normalizedSearchText) {
                return true;
            }

            const searchableValues = [
                record?.event_name,
                record?.market_name,
                record?.market_id,
                record?.place_name,
                record?.runner_name,
                record?.result_name,
                record?.remarks,
                record?.transaction_type,
                record?.type,
                record?.totalPL,
                record?.totalBalance,
                record?.amount,
                record?.from,
                record?.to,
            ];

            return searchableValues.some((value) =>
                String(value ?? "")
                    .toLowerCase()
                    .includes(normalizedSearchText)
            );
        })
        : [];

    const handleFirst = () => setCurrent(1);

    const handleLast = () => {
        setCurrent(
            Math.max(
                1,
                Math.ceil(
                    searchedData.length / pageSize
                )
            )
        );
    };

    const startIndex =
        (current - 1) * pageSize;

    const endIndex =
        startIndex + pageSize;

    const paginatedData =
        searchedData.slice(
            startIndex,
            endIndex
        );

    useEffect(() => {
        filterProfitLoss();
    }, [])


    const filterProfitLoss = async (e) => {

        var data = JSON.stringify(formData);

        var config = {
            method: 'post',
            url: `${Appconfig.apiUrl}reports/auraProfitLossByEventMarketsAll`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(config)
            .then(function (response) {
                try {
                    // console.log(response.data.resultData);
                    setRequestType(formData?.type);

                    setFilteredData(response.data.resultData);

                } catch (e) {
                    // postErrorToslack(e.message);
                }
            })
            .catch(function (error) {
                console.log(error);
                // postErrorToslack(error.message);
            });
    }


    const onChangeDataType = (datatype) => {
        if (datatype == "LIVE") {
            setFormData({
                ...formData,
                from_date: moment().format('YYYY-MM-DD')
            })
        } else if (datatype == "BACKUP") {
            setFormData({
                ...formData,
                from_date: moment().subtract(3, 'month').format('YYYY-MM-DD')
            })
        } else if (datatype == "OLD") {
            setFormData({
                ...formData,
                from_date: moment().subtract(1, 'year').format('YYYY-MM-DD')
            })
        }

    }


    return (
        <div className="account-statement-page">

            {/* Filter Section */}
            <section className="statement-filter-card">

                <div className="statement-filter-grid">

                    <div className="statement-filter-field">
                        <label htmlFor="statement-type">
                            Type
                        </label>

                        <select
                            id="statement-type"
                            className="statement-filter-select"
                            value={formData.type}
                            onChange={(event) =>
                                handleChangeType(
                                    event.target.value
                                )
                            }
                        >
                            <option value="All">
                                ALL
                            </option>

                            <option value="D&W">
                                D & W
                            </option>

                            <option value="WCO">
                                WCO
                            </option>

                            <option value="Sports">
                                Sports
                            </option>
                        </select>
                    </div>

                    <div className="statement-filter-field">
                        <label>From</label>

                        <DatePicker
                            showTime={{
                                format: "HH:mm",
                            }}
                            format="DD-MM-YYYY HH:mm"
                            value={dayjs(
                                formData.from_date
                            )}
                            className="statement-date-picker"
                            onChange={(
                                date,
                                dateString
                            ) => {
                                if (!date) {
                                    return;
                                }

                                setFormData({
                                    ...formData,
                                    from_date:
                                        dayjs(
                                            dateString,
                                            "DD-MM-YYYY HH:mm"
                                        ).toDate(),
                                });
                            }}
                        />
                    </div>

                    <div className="statement-filter-field">
                        <label>To</label>

                        <DatePicker
                            showTime={{
                                format: "HH:mm",
                            }}
                            format="DD-MM-YYYY HH:mm"
                            value={dayjs(
                                formData.to_date
                            )}
                            className="statement-date-picker"
                            onChange={(
                                date,
                                dateString
                            ) => {
                                if (!date) {
                                    return;
                                }

                                setFormData({
                                    ...formData,
                                    to_date:
                                        dayjs(
                                            dateString,
                                            "DD-MM-YYYY HH:mm"
                                        ).toDate(),
                                });
                            }}
                        />
                    </div>

                    <div className="statement-filter-action">
                        <Button
                            type="primary"
                            onClick={filterProfitLoss}
                            className="statement-filter-button"
                        >
                            Get P&amp;L
                        </Button>
                    </div>

                </div>
            </section>

            {/* Account Statement Section */}
            <section className="statement-history-card">

                <div className="statement-history-header">
                    <span>Account Statement</span>
                </div>

                <div className="statement-history-body">

                    <Table
                        title={() => (
                            <div className="statement-table-toolbar">

                                <div className="statement-page-size">
                                    <label>
                                        <span>Show</span>

                                        <Select
                                            value={pageSize}
                                            onChange={
                                                handlePageSizeChange
                                            }
                                            className="statement-pagesize-select"
                                        >
                                            <Select.Option value={10}>
                                                10
                                            </Select.Option>

                                            <Select.Option value={25}>
                                                25
                                            </Select.Option>

                                            <Select.Option value={50}>
                                                50
                                            </Select.Option>

                                            <Select.Option value={100}>
                                                100
                                            </Select.Option>
                                        </Select>

                                        <span>entries</span>
                                    </label>
                                </div>

                                <div className="statement-search">
                                    <label>
                                        <span>Search:</span>

                                        <Input
                                            value={searchText}
                                            allowClear
                                            placeholder="Search statement"
                                            className="statement-search-input"
                                            onChange={(event) => {
                                                setSearchText(
                                                    event.target.value
                                                );
                                                setCurrent(1);
                                            }}
                                        />
                                    </label>
                                </div>

                            </div>
                        )}
                        locale={locale}
                        columns={
                            requestType === "D&W"
                                ? columnsdw
                                : columns
                        }
                        className="statement-history-table"
                        bordered
                        dataSource={
                            Array.isArray(paginatedData)
                                ? paginatedData
                                : []
                        }
                        pagination={false}
                        scroll={{
                            x: "max-content",
                        }}
                        rowKey={(record, index) =>
                            record?._id ||
                            [
                                record?.match_id,
                                record?.market_id,
                                record?.selection_id,
                                record?.settledTime,
                                index,
                            ].join("-")
                        }
                    />

                    <div className="statement-pagination-row">

                        <div className="statement-entry-info">
                            Showing{" "}
                            {searchedData.length > 0
                                ? startIndex + 1
                                : 0}{" "}
                            to{" "}
                            {Math.min(
                                endIndex,
                                searchedData.length || 0
                            )}{" "}
                            of{" "}
                            {searchedData.length || 0}{" "}
                            entries
                        </div>

                        <div className="statement-pagination-controls">

                            <button
                                type="button"
                                className="statement-pagination-button"
                                onClick={handleFirst}
                                disabled={current === 1}
                            >
                                First
                            </button>

                            <Pagination
                                current={current}
                                pageSize={pageSize}
                                total={
                                    searchedData.length || 0
                                }
                                onChange={(page) =>
                                    setCurrent(page)
                                }
                                className="statement-pagination"
                                itemRender={(
                                    page,
                                    type,
                                    originalElement
                                ) => {
                                    if (type === "prev") {
                                        return (
                                            <span className="statement-page-link">
                                                Previous
                                            </span>
                                        );
                                    }

                                    if (type === "page") {
                                        return null;
                                    }

                                    if (type === "next") {
                                        return (
                                            <span className="statement-page-link">
                                                Next
                                            </span>
                                        );
                                    }

                                    return originalElement;
                                }}
                                showSizeChanger={false}
                            />

                            <button
                                type="button"
                                className="statement-pagination-button"
                                onClick={handleLast}
                                disabled={
                                    current >=
                                    Math.max(
                                        1,
                                        Math.ceil(
                                            (searchedData.length ||
                                                0) /
                                            pageSize
                                        )
                                    )
                                }
                            >
                                Last
                            </button>

                        </div>
                    </div>

                </div>
            </section>
        </div>
    )
}


export default ProfitLoss;
